module.exports = __webpack_public_path__ + "static/img/net-border-4.73a41f5a.png";